import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import styled, { ThemeProvider } from 'styled-components';
import {
  BreakpointDisplay,
  FlashMessage,
  Footer,
  NavDrawer,
  TopBar,
} from 'components/shared';
import { get as getCookie } from 'js-cookie';
import { theme, media } from 'styles';
import { createCart, fetchCart } from 'ducks/cart';
import { fetch as fetchMarketerSessions } from 'ducks/marketerSessions';
import guestCartCookieName from 'helpers/guestCartCookieName';

import './index.css';

const Wrapper = styled.div`
  font-weight: 500;
  color: ${theme.colors.navy};
  -webkit-font-smoothing: antialiased;
  padding-top: 60px;
  ${media.ldesktop`
    padding-top: 80px;
  `};
`;

class TemplateWrapper extends React.Component {
  static propTypes = {
    onCreateCart: PropTypes.func.isRequired,
    onFetchCart: PropTypes.func.isRequired,
    onFetchMarketerSessions: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
    data: PropTypes.shape({ allMarketTapProductCategory: PropTypes.object })
      .isRequired,
  };

  componentDidMount() {
    if (!getCookie(guestCartCookieName)) {
      this.props.onCreateCart();
    }
    if (getCookie(guestCartCookieName)) {
      this.props.onFetchCart(getCookie(guestCartCookieName));
    }
    this.props.onFetchMarketerSessions();
  }

  render() {
    const { children, data: { allMarketTapProductCategory } } = this.props;
    const productCategories = allMarketTapProductCategory.edges.map(
      e => e.node,
    );

    return (
      <Wrapper>
        <Helmet
          title="On Demand Marketing Services | Hire a Marketer | MarketTap"
          meta={[
            {
              name: 'description',
              content:
                'MarketTap is a simple marketing platform that sells on-demand marketing services. We specialize in helping small businesses sell more online. Purchase from our a la carte marketing services today.',
            },
            {
              name: 'keywords',
              content: 'marketing, social, copywriting, video production',
            },
            {
              name: 'viewport',
              content:
                'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
            },
          ]}
        />
        <FlashMessage />
        <TopBar productCategories={productCategories} />
        <NavDrawer productCategories={productCategories} />

        <ThemeProvider theme={theme}>{children()}</ThemeProvider>

        <Footer productCategories={productCategories} />

        {process.env.NODE_ENV === 'development' && <BreakpointDisplay />}
      </Wrapper>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  onCreateCart: createCart,
  onFetchCart: fetchCart,
  onFetchMarketerSessions: fetchMarketerSessions,
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateWrapper);

export const query = graphql`
  query ProductCategoryQuery {
    allMarketTapProductCategory {
      edges {
        node {
          id
          slug
          name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js